<!-- <footer class="footer mt-auto py-3 text-center">
    <div class="container">
      <ul class="list-inline">
        <li class="list-inline-item"><a href="mailto:calidad@certant.com">calidad@certant.com</a></li>

        <li class="list-inline-item"><a href="https://goo.gl/maps/8ajd2yNHQrwJPvPcA" target="_blank">Chacabuco 271, Piso 7, Buenos Aires, Argentina</a></li>

        <li class="list-inline-item">+54 11 5219 - 0855</li>
      </ul>
    </div>
</footer> -->
<footer class="footer mt-auto py-3">
  <div class="container">
    <ul class="list-unstyled d-flex flex-wrap justify-content-start justify-content-md-center align-items-center mb-0 footer-list">
      <li class="mx-3 my-1">
        <a class="d-inline-flex align-items-center" href="mailto:calidad@certant.com">
          <i class="fas fa-envelope mr-2 footer-icon"></i>
          <span>calidad@certant.com</span>
        </a>
      </li>

      <li class="mx-3 my-1">
        <a class="d-inline-flex align-items-center" href="https://goo.gl/maps/8ajd2yNHQrwJPvPcA" target="_blank" rel="noopener noreferrer">
          <i class="fas fa-map-marker-alt mr-2 footer-icon"></i>
          <span>Chacabuco 271, Piso 7, Buenos Aires, Argentina</span>
        </a>
      </li>

      <li class="mx-3 my-1 d-inline-flex align-items-center">
        <i class="fas fa-phone mr-2 footer-icon"></i>
        <span>+54 11 5219 - 0855</span>
      </li>
    </ul>
  </div>
</footer>